import React, { useEffect, useState } from 'react';
import { Formik, Form, FormikHelpers } from 'formik';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import Button from 'components/Button/Index';
import Activation from 'components/feature/activation/Index';
import useLocales from 'hooks/useLocales';
import { MatchProfileService } from 'services/matchProfile/matchProfile';
import Checkboxes from 'components/shared/Checkbox/Index';
import { validationSchema } from './form';

import './Index.scss';

const JobOpenings: any = ({
  onSubmit,
  onBack,
  onClose,
  setCompanyData,
  companyData,
  isPopup = false,
  className,
  isOneBtn = false,
  showTopSide,
  setNewData,
  showTitle
}: any): JSX.Element => {
  const { t } = useLocales();
  const [formValues, setFormValues] = useState<any>({
    show_jobs: companyData?.show_jobs || false
  });

  const handleSubmit = async (values: any, actions: FormikHelpers<any>) => {
    if (setCompanyData) {
      setCompanyData((prev: any) => ({
        ...prev,
        ...values
      }));
      onSubmit && onSubmit();
    } else {
      const data = {
        ...values
      };
      setNewData && setNewData(data);
    }
  };

  return (
    <div
      className="who"
      onClick={isPopup ? (e) => e.stopPropagation() : () => {}}
    >
      <Activation
        title={t('Job openings')}
        showTopSide={showTopSide}
        currentStep={2}
        className={
          isPopup ? '' : `activation-edu ${className ?? ''} ${className}`
        }
        headerIconDisable
        totalSteps={8}
        isCareerPage={true}
        handleModalClose={onClose}
        isPopup={true}
        showTitle={showTitle}
      >
        <Formik
          enableReinitialize
          initialValues={formValues}
          onSubmit={(values, actions) => handleSubmit(values, actions)}
          validationSchema={validationSchema(t)}
        >
          {({
            setFieldValue,
            isValid,
            setFieldError,
            values,
            errors,
            touched,
            setFieldTouched
          }) => {
            return (
              <Form>
                <div className="containerJob">
                  <div className="addJob">
                    <div className="fields">
                      <Checkboxes
                        onArrayChange={(e) => {
                          if (Array.isArray(e)) {
                            setFieldValue('show_jobs', e[0].isChecked);
                          }
                        }}
                        checkboxes={[
                          {
                            label: 'Show all jobs on career page',
                            isChecked: values.show_jobs
                          }
                        ]}
                      />
                      <p className="description">
                        {t(
                          "If you don’t check this, only published jobs with ‘Show this job on my career page' enabled will appear on your career page."
                        )}
                      </p>
                    </div>
                  </div>
                  {!isOneBtn ? (
                    <div className="button_container">
                      <Button
                        onClick={onBack}
                        t={t}
                        title="Back"
                        className="av__content__buttons-back"
                      />

                      <Button
                        className={`next ${
                          !isValid ? 'invalid' : `${isValid}`
                        }`}
                        type="submit"
                        title="Next"
                        t={t}
                      />
                    </div>
                  ) : (
                    <div className="btn_container">
                      <Button
                        className="next button one-btn"
                        type="submit"
                        t={t}
                        title={'Save'}
                      />
                    </div>
                  )}
                </div>
              </Form>
            );
          }}
        </Formik>
      </Activation>
    </div>
  );
};

export default JobOpenings;
